import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type FilterType = 'all' | 'open' | 'done';

export interface PerfectTruckDashboardFilters {
  filter: FilterType;
  locationName?: string;
  deliveryDate?: string;
  searchQuery: string;
}

interface PerfectTruckDashboardFiltersState {
  filters: PerfectTruckDashboardFilters | null;
  lastLocationId: string | undefined;
}

const initialState: PerfectTruckDashboardFiltersState = {
  filters: null,
  lastLocationId: undefined,
};

const perfectTruckDashboardFiltersSlice = createSlice({
  name: 'perfectTruckDashboardFilters',
  initialState,
  reducers: {
    saveFilters: (state, action: PayloadAction<PerfectTruckDashboardFilters>) => {
      state.filters = action.payload;
    },
    setLastLocationId: (state, action: PayloadAction<string | undefined>) => {
      state.lastLocationId = action.payload;
    },
    clearFilters: (state) => {
      state.filters = null;
    },
    resetDashboardFiltersState: () => initialState,
  },
});

export const { saveFilters, setLastLocationId, clearFilters, resetDashboardFiltersState } =
  perfectTruckDashboardFiltersSlice.actions;
export default perfectTruckDashboardFiltersSlice.reducer;
